<template src="./template.html" />

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import mixin from '@/mixins/mixins.js';
import Btn from '@/components/elements/buttons';
import UploadArea from '@/components/elements/inputs/uploadArea.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import InputText from '@/components/elements/inputs/text.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';
import EventBus from '@/eventBus.js';

export default {
  name: 'UploadTemplate',
  mixins: [mixin],
  components: {
    Btn,
    UploadArea,
    InputSelect,
    InputText,
    Toggle,
  },
  props: {
    templateType: {
      type: String,
      default: 'customer_fields',
      required: true,
    }
  },
  data() {
    return {
      importId: '',
      progressId: '',
      uploadStage: '',
      importing: false,
      existingTemplate: true,
      // Existing template data
      templateId: '',
      file: null,
      // Map template data
      fileType: '',
      readingType: '',
      startRow: '',
      separator: '',
      templateName: '',
      saveTemplate: false,
      requiredFieldsData: {},
      additionalMappingFields: [],
      uploadFileError: [],
    };
  },
  computed: {
    ...mapGetters([
      'get_error_message',
      'get_templates',
      'get_template_field',
      'get_upload_progress',
      'get_active_subaccount',
    ]),
    disableUpload() {
      if(this.existingTemplate){
        if( this.templateId === '') return true;
        return false;
      } else {
        if(
          this.fileType === '' || this.readingType === '' || this.startRow === '' || this.separator === '' ||
          this.requiredFieldsData.name === '' || this.requiredFieldsData.adress_1 === '' || this.requiredFieldsData.city === '' ||
          this.requiredFieldsData.post_code === '' || this.requiredFieldsData.country_code === '' || this.requiredFieldsData.type === '' ||
          this.requiredFieldsData.phone === '' || this.requiredFieldsData.email === ''
        ){
          return true;
        } else {
          return false;
        }
      }
    },
    additionalMappingOptions() {
      return this.get_templates.entity[0][this.templateType].filter(opt => !opt.required);
    },
  },
  mounted() {
    EventBus.$on('import_template',() => {
      this.startImport();
    });
  },
  methods: {
    startUpload(){
      this.uploadStage = `${this.$t('1/2 uploading')}`;
      if( this.existingTemplate ){
        this.$store.dispatch('UPLOAD_TEMPLATE', {
          id: this.templateId,
          file: this.file,
          subaccountId: this.get_active_subaccount.id,
        })
        .then((res) => {
          this.startCheckProgress(res);
        });
      } else {
        this.$store.dispatch('CREATE_TEMPLATE', {
          name: this.templateName,
          template_type: this.templateType,
          template_reading_type: this.readingType,
          template_separator: this.separator,
          template_file_type: this.fileType,
          sheet_number: 1,
          start_from_row: this.startRow,
          fields_json: this.spreadFields(),
        })
        .then((res) => {
          this.templateId = res.data.items.id;
          this.$store.dispatch('UPLOAD_TEMPLATE', {
            id: res.data.items.id,
            file: this.file,
            subaccountId: this.get_active_subaccount.id,
          }).then((res) => {
            this.startCheckProgress(res);
          });
        })
      }
    },
    startCheckProgress(res) {
      this.$store.commit('STORE_UPLOAD_PROGRESS', 0);
      this.uploadStage = `${this.$t('2/2 validation')}`;
      this.importId = res.data.data.import_id;
      this.progressId = res.data.data.progress_id;
      this.trackProgressValidation(res.data.data.progress_id).then((id) => {
        this.validateFile(id).then((res) => {
          if(res.data.data.length !== 0) {
            this.$store.commit('SHOW_NOTIFICATION_BAR', JSON.parse(res.data.data.payload_json));
          } else {
            this.$emit('enabeImport');
          }
        });
      });
    },
    trackProgressValidation(id) {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('TRACK_VALIDATION_PROGRESS', id)
        .then((res) => {
            if(res.data.data !== 'progress-done'){
              this.$store.commit('STORE_UPLOAD_PROGRESS', res.data.data);
              const self = this;
              setTimeout(() => {
                resolve(self.trackProgressValidation(id));
              }, 2000);
            } else {
              this.$store.commit('STORE_UPLOAD_PROGRESS', 100);
              resolve(id);
            }
        });
      });
    },
    startImport() {
      this.$store.dispatch('START_TEMPLATE_IMPORT', {
        templateId: this.templateId,
        importId: this.importId,
        fileName: this.file.name,
        templateType: this.templateType,
        progressStatus: 0,
        iconName: this.templateType == 'customer_fields' ? 'contacts' : 'truck',
      })
      .then((res) => {
        this.$emit('closePopup');
      });
    },
    validateFile(id) {
      return this.$store.dispatch('VALIDATE_ERRORS', id);
    },
    spreadFields() {
      const fields = [];
      for(const item in this.requiredFieldsData) {
        fields.push({
          field_name: item,
          file_column: this.requiredFieldsData[item],
        });
      }
      return fields;
    },
    fieldSelected(val) {
      // this.additionalMappingFields.push(val);
    },
    addNewField() {
      this.additionalMappingFields.push({

      })
    },
    selectOptions(opt) {
      return opt.map(opt => {
        return { text: opt.name, value: opt.id };
      });
    },
    submitForm() {
      this.$store.dispatch('UPLOAD_TEMPLATE', {
        id: this.templateId,
        file: this.file,
        subaccountId: this.get_active_subaccount.id,
      });
    },
    changeFile(file) {
      this.file = file;
      this.startUpload();
    },
    showNotification(val) {
      this.$store.commit('SHOW_ERROR', `Select promenjen: ${val}`)
    },
    getTemplatesByType(type) {
      return this.get_templates.items.filter((obj) => {
        return obj.template_type === type;
      });
    }
  },
  beforeDestroy(){
    EventBus.$off('import_template');
  },
  destroyed() {
    this.$store.commit('RESET_NOTIFICATION_BAR')
    this.$emit('disableImport');
    this.$store.commit('STORE_UPLOAD_PROGRESS', 0);
  },
}
</script>
